import { AppAreaConfig } from '@/funnels/@types'

type FunnelGroup = {
	id: string
	name: string
	appAreas: AppAreaConfig[]
}

export const FUNNEL_GROUPS: FunnelGroup[] = [
	{
		id: 'fasting',
		name: 'Fasting',
		appAreas: [
			require('./areas/fasting/female').default,
			require('./areas/fasting/male').default,
			require('./areas/fasting/main').default,
			require('./areas/fasting/female-water-balance').default,
			require('./areas/fasting/female-water-fasting').default,
			require('./areas/fasting/female-ayurveda-fwf').default,
		],
	},
	{
		id: 'yoga',
		name: 'Yoga',
		appAreas: [
			require('./areas/yoga/activity-female-yoga').default,
			require('./areas/yoga/activity-male-chair-workouts').default,
			require('./areas/yoga/main-yoga').default,
		],
	},
	{
		id: 'walking',
		name: 'Walking',
		appAreas: [
			require('./areas/walking/activity-female-walking').default,
			require('./areas/walking/activity-female-nordic-walking-fwf').default,
			require('./areas/walking/activity-male-walking').default,
			require('./areas/walking/female-printable-walking').default,
			require('./areas/walking/activity-female-walking-japanese').default,
			require('./areas/walking/activity-female-walking-japanese-v2').default,
			require('./areas/walking/main-walking').default,
		],
	},
	{
		id: 'pilates',
		name: 'Pilates',
		appAreas: [
			require('./areas/pilates/activity-female-pilates').default,
			require('./areas/pilates/activity-female-senior-pilates').default,
			require('./areas/pilates/activity-female-boudoir-pilates-fwf').default,
			require('./areas/pilates/activity-female-asian-pilates').default,
		],
	},
	{
		id: 'activity',
		name: 'Activity',
		appAreas: [
			require('./areas/activity/activity-female-v2').default,
			require('./areas/activity/activity-male').default,
			require('./areas/activity/main-activity').default,
		],
	},
	{
		id: 'tai-chi',
		name: 'Tai Chi',
		appAreas: [
			require('./areas/tai-chi/activity-female-tai-chi').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking-v2').default,
			require('./areas/tai-chi/activity-female-tai-chi-walking-pr').default,
			require('./areas/tai-chi/activity-female-chair-tai-chi-fwf').default,
			require('./areas/tai-chi/activity-male-tai-chi-walking').default,
			require('./areas/tai-chi/activity-male-tai-chi-yoga').default,
			require('./areas/tai-chi/activity-male-tai-chi-yoga-pr').default,
			require('./areas/tai-chi/main-tai-chi').default,
			require('./areas/tai-chi/main-tai-chi-walking').default,
			require('./areas/tai-chi/activity-male-chair-tai-chi-fwf').default,
			require('./areas/tai-chi/tai-chi-male-golfers-fwf').default,
		],
	},
	{
		id: 'glp',
		name: 'GLP',
		appAreas: [require('./areas/glp/female-glp').default, require('./areas/glp/glp-1').default],
	},
	{
		id: 'calisthenics',
		name: 'Calisthenics',
		appAreas: [
			require('./areas/calisthenics/activity-female-calisthenics').default,
			require('./areas/calisthenics/activity-male-calisthenics').default,
			require('./areas/calisthenics/main-calisthenics').default,
			require('./areas/calisthenics/military-male').default,
		],
	},
	{
		id: 'diets',
		name: 'Diets',
		appAreas: [
			require('./areas/diets/female-cortisol-diet').default,
			require('./areas/diets/female-menopause-diet').default,
			require('./areas/diets/female-mediterranean-diet').default,
			require('./areas/diets/female-anti-inflammatory-diet').default,
			require('./areas/diets/female-high-protein').default,
			require('./areas/diets/female-ramadan-fwf').default,
		],
	},
	{
		id: 'applovin',
		name: 'AppLovin',
		appAreas: [
			require('./areas/applovin/main-tai-chi-walking-al').default,
			require('./areas/applovin/activity-female-pilates-al').default,
			require('./areas/applovin/activity-female-walking-al').default,
			require('./areas/applovin/activity-female-yoga-al').default,
			require('./areas/applovin/activity-male-tai-chi-walking-al').default,
			require('./areas/applovin/main-al').default,
			require('./areas/applovin/female-al').default,
			require('./areas/applovin/male-al').default,
			require('./areas/applovin/activity-female-tai-chi-walking-al').default,
			require('./areas/applovin/activity-female-tai-chi-walking-v2-al').default,
		],
	},
	{
		id: 'other',
		name: 'Other',
		appAreas: [
			require('./areas/other/assessment').default,
			require('./areas/other/together').default,
			require('./areas/other/workbooks').default,
		],
	},
]

export const APP_AREAS: AppAreaConfig[] = FUNNEL_GROUPS.flatMap((group) => group.appAreas)
